import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { connect, useDispatch, useSelector } from "react-redux";
import { GET_APP_SHOP, SET_IS_WAITER, SignInAction } from "../store/actions/AuthActions";
import logo from "../assets/images/logo.png"
import { url } from "../config/BaseUrl";
import { TOAST } from "../utils/Helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Login = ({ shop }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isCheckingAuth, setCheckingAuth] = useState(true);
    const [isShowPassword, setShowPassword] = useState(false);
    const [isConnecting, setConnecting] = useState(false);
    const [user, setUser] = useState({
        email: "", password: ""
    });

    useEffect(() => {
        checkAuthentication()
    }, [])

    const handleChange = (prop) => (event) => {
        setUser({ ...user, [prop]: event.target.value });
    };

    async function checkAuthentication() {

        let token = localStorage.getItem("token")
        if (token) {
            dispatch(GET_APP_SHOP());
            const headers = { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` }
            url.get(`shops/${localStorage.getItem("shop_id")}`, { headers: headers })
                .then(res => {
                    if (res.data.name === "Chez Polli") {
                        navigate("/select-waiter")
                    } else {
                        navigate("/home")
                    }
                })
                .catch(err => { console.log(err); })

        } else {
            setCheckingAuth(false)
        }
    }

    const submitFormHandler = async (e) => {
        setConnecting(true);
        e.preventDefault();
        await url.post("auth/login", JSON.stringify(user),
            { headers: { 'Content-Type': 'application/json' } })
            .then(async (res) => {
                console.log("res")
                console.log(res)
                if (res.status === 200) {
                    localStorage.setItem("token", res.data.token);
                    localStorage.setItem("shop_id", res.data.shops[0]?._id);
                    localStorage.setItem("shop_name", res.data.shops[0]?.name);
                    setTimeout(() => {
                        dispatch(SignInAction(res.data));
                        dispatch(GET_APP_SHOP());
                        navigate(res.data.shops[0]?.name === "Chez Polli" ? '/select-waiter' : '/home')
                        setConnecting(false)
                    }, 500)
                } else {
                    TOAST("Adresse e-mail ou mot de passe incorrect", "error")
                    setConnecting(false)
                }
            })
            .catch((error) => {
                TOAST("Adresse e-mail ou mot de passe incorrect", "error")
                setConnecting(false)
            })
    }

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            {
                (isConnecting || isCheckingAuth) ?
                    <div role="status">
                        <svg aria-hidden="true" class="inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>
                    : <section className="bg-white shadow-xl rounded-xl mx-auto my-auto md:px-10 h-full md:h-auto">
                        <img className="w-8/12 md:w-11/12 md:h-70 lg:w-10/12 2xl:w-7/12 mx-auto pt-10" style={{ objectFit: 'contain' }} src={logo} alt="" />
                        <div className="w-full md:w-2/2 justify-center items-center">
                            <form className="py-2 h-2/3 mt-10" method="Post" onSubmit={submitFormHandler}>
                                <div className="pt-3 px-10 md:px-4">
                                    <label for="email">Adresse e-mail :</label>
                                    <input autoCorrect={false} autoCapitalize="none" type="text" name="email" id="email" onChange={handleChange("email")} className="h-10 border mt-1 border-gray-300 rounded px-4 w-full bg-white" value={user.email} placeholder="email@domain.com" />
                                </div>
                                <div className="pt-5 px-10 md:px-4">
                                    <label for="email">Mot de passe :</label>
                                    <div className="flex item-center justify-center border-gray-300 border rounded">
                                        <input autoCorrect={false} autoCapitalize="none" type={isShowPassword ? "text" : "password"} name="password" id="password" onChange={handleChange("password")} className="h-10 mt-1 rounded px-4 w-full bg-white" value={user.password} placeholder="*********" />
                                        <FontAwesomeIcon icon={isShowPassword ? faEyeSlash : faEye} onClick={() => setShowPassword(!isShowPassword)} style={{ color: "black", height: 18, width: 18, marginTop: 12, marginRight: 10, marginLeft: 10 }} />
                                    </div>
                                </div>
                                <div className="text-center pb-3 px-10 md:px-4">
                                    <button type="submit" className="bg-primary py-5 px-2 lg:px-4 w-full text-lg font-sans font-semibold rounded-lg mt-6 mx-auto text-white" style={{ backgroundColor: '#E92D3F' }}>SE CONNECTER</button>
                                </div>
                            </form>
                        </div>
                    </section>
            }

        </div>
    )
}

function mapStateToProps(state) {
    return {
        shop: state.auth.shops,
    }
}

export default connect(mapStateToProps)(Login);